"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "clearLicenseStatusCache", {
  enumerable: true,
  get: function () {
    return _useLicenseVerifier.clearLicenseStatusCache;
  }
});
Object.defineProperty(exports, "useLicenseVerifier", {
  enumerable: true,
  get: function () {
    return _useLicenseVerifier.useLicenseVerifier;
  }
});
var _useLicenseVerifier = require("./useLicenseVerifier");